export const POLICIES_ALL = '/policies/all' as const
export const MODULE_FILE = '/module_file/' as const
export const MODULE_FILE_ACTIVATE = `${MODULE_FILE}activate/` as const
export const MODULE_FILE_ALL = `${MODULE_FILE}all` as const
